import { type LoggerMetaData } from '@zoopla/logger';

export const LOGGER_METADATA: LoggerMetaData = {
    page: 'valuation',
    custodian: 'sell',
};
